/**
 * Escape special characters using replace.
 */
export function regExpEscape(stringValue: string): string {
    return stringValue.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
